import hoistNonReactStatics from 'hoist-non-react-statics';
import { ReactRouterVersion } from '../types';
import { FaroRoutes } from './FaroRoutes';
import { setReactRouterV6DataRouterDependencies as setReactRouterV6DataRouterDependencies, setReactRouterV6Dependencies, } from './routerDependencies';
export function initializeReactRouterV6Instrumentation(dependencies) {
    hoistNonReactStatics(FaroRoutes, dependencies.Routes);
    setReactRouterV6Dependencies(dependencies);
}
export function createReactRouterV6Options(dependencies) {
    return {
        version: ReactRouterVersion.V6,
        dependencies,
    };
}
export function initializeReactRouterV6DataRouterInstrumentation(dependencies) {
    setReactRouterV6DataRouterDependencies(dependencies);
}
export function createReactRouterV6DataOptions(dependencies) {
    return {
        version: ReactRouterVersion.V6_data_router,
        dependencies,
    };
}
//# sourceMappingURL=initialize.js.map